// src/components/SubscriberLayout.js
// Guardian Dubai subscriber-facing AppShell — mirrors PatientLayout.js.

import React, { useState, useCallback, useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useSubscriber } from '../context/SubscriberContext';
import AccountMenu from './AccountMenu';
import Icon from './Icon';
import previuLogo from '../assets/previu-logo-white.png';

const SUBSCRIBER_NAV = [
  { to: '/subscriber/dashboard', icon: 'people', label: 'My Family',       section: null },
  { to: '/subscriber/chat',      icon: 'chat', label: 'Chat',            section: null },
  { to: '/subscriber/plan',      icon: 'card', label: 'Plan & Billing',  section: null },
];

export function SubscriberTopbar({ breadcrumbs = [], onMenuToggle }) {
  const { subscriber, logout } = useSubscriber();
  const navigate = useNavigate();

  const initials = subscriber
    ? `${subscriber.firstName?.[0] ?? ''}${subscriber.lastName?.[0] ?? ''}`.toUpperCase()
    : 'G';

  return (
    <header className="topbar">
      <button
        className="hamburger-btn"
        onClick={onMenuToggle}
        aria-label="Toggle navigation menu"
        type="button"
      >
        ☰
      </button>

      <div className="topbar-logo">
        <img src={previuLogo} alt="Previu" style={{ height: 34, width: 'auto' }} />
      </div>

      <nav className="topbar-breadcrumb">
        {breadcrumbs.map((crumb, i) => (
          <React.Fragment key={crumb.label}>
            {i > 0 && <span className="crumb-sep">/</span>}
            {i === breadcrumbs.length - 1
              ? <span className="crumb-active">{crumb.label}</span>
              : <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => crumb.to && navigate(crumb.to)}
                >{crumb.label}</span>
            }
          </React.Fragment>
        ))}
      </nav>

      <div className="topbar-actions">
        <AccountMenu
          initials={initials}
          name={subscriber ? `${subscriber.firstName} ${subscriber.lastName}` : 'Guardian'}
          role="Subscriber"
          secondary={subscriber?.email}
          onLogout={logout}
        />
      </div>
    </header>
  );
}

export function SubscriberSidebar({ isOpen, onClose }) {
  return (
    <aside className={`sidebar${isOpen ? ' open' : ''}`}>
      {SUBSCRIBER_NAV.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
          onClick={onClose}
        >
          <span className="nav-icon"><Icon name={item.icon} /></span>
          {item.label}
        </NavLink>
      ))}
    </aside>
  );
}

export function SubscriberAppShell({ children, breadcrumbs }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = useCallback(() => setMenuOpen(prev => !prev), []);
  const closeMenu  = useCallback(() => setMenuOpen(false), []);

  return (
    <div className="app-shell">
      <SubscriberTopbar breadcrumbs={breadcrumbs} onMenuToggle={toggleMenu} />
      <SubscriberSidebar isOpen={menuOpen} onClose={closeMenu} />
      {menuOpen && (
        <div className="sidebar-overlay" onClick={closeMenu} aria-hidden="true" />
      )}
      <main className="main-content">
        {children}
      </main>
    </div>
  );
}